import React from "react";
import classNames from "classnames";
import * as c from "./lpCompetitorQuoteGlow.module.scss";

const LpCompetitorQuoteGlow = ({ className, style }) => {
  return (
    <>
      {/* Mobile SVG */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100vw"
        height="895"
        fill="none"
        className={classNames(c.mobile, className)}
        style={style}
      >
        <g filter="url(#a-mobile)" opacity=".5">
          <ellipse
            cx="113.696"
            cy="247.5"
            fill="#FFEBDD"
            rx="113.696"
            ry="247.5"
            transform="matrix(1 0 0 -1 229.608 695)"
          />
        </g>
        <g filter="url(#b-mobile)" opacity=".5">
          <ellipse
            cx="113.696"
            cy="247.5"
            fill="#E9DBFC"
            rx="113.696"
            ry="247.5"
            transform="matrix(1 0 0 -1 -66 695)"
          />
        </g>
        <g filter="url(#c-mobile)" opacity=".5">
          <ellipse
            cx="113.696"
            cy="247.5"
            fill="#FDDFEE"
            rx="113.696"
            ry="247.5"
            transform="matrix(1 0 0 -1 81.805 695)"
          />
        </g>
        <defs>
          <filter
            id="a-mobile"
            width="627.392"
            height="895"
            x="29.608"
            y="0"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_11980_21489" stdDeviation="100" />
          </filter>
          <filter
            id="b-mobile"
            width="627.392"
            height="895"
            x="-266"
            y="0"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_11980_21489" stdDeviation="100" />
          </filter>
          <filter
            id="c-mobile"
            width="627.392"
            height="895"
            x="-118.195"
            y="0"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_11980_21489" stdDeviation="100" />
          </filter>
        </defs>
      </svg>

      {/* Desktop SVG */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1320"
        height="800"
        fill="none"
        className={classNames(c.desktop, className)}
        style={style}
      >
        <g filter="url(#a)" opacity=".5">
          <circle cx="200" cy="200" r="200" fill="#FFEBDD" transform="matrix(1 0 0 -1 720 600)" />
        </g>
        <g filter="url(#b)" opacity=".5">
          <circle cx="200" cy="200" r="200" fill="#E9DBFC" transform="matrix(1 0 0 -1 200 600)" />
        </g>
        <g filter="url(#c)" opacity=".5">
          <circle cx="200" cy="200" r="200" fill="#FDDFEE" transform="matrix(1 0 0 -1 460 600)" />
        </g>
        <defs>
          <filter
            id="a"
            width="800"
            height="800"
            x="520"
            y="0"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_11872_39225" stdDeviation="100" />
          </filter>
          <filter
            id="b"
            width="800"
            height="800"
            x="0"
            y="0"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_11872_39225" stdDeviation="100" />
          </filter>
          <filter
            id="c"
            width="800"
            height="800"
            x="260"
            y="0"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_11872_39225" stdDeviation="100" />
          </filter>
        </defs>
      </svg>
    </>
  );
};

export default LpCompetitorQuoteGlow;
